
const getSbUrl = (uri = "") => process.env.REACT_APP_SB_URL + uri

export default getSbUrl
